import PropTypes from 'prop-types';

export const BACKGROUND_JOBS__GET = 'BACKGROUND_JOBS__GET';
export const BACKGROUND_JOBS__FETCH = 'BACKGROUND_JOBS__FETCH';
export const BACKGROUND_JOBS__FETCH_UPDATED_IN_ORG = 'BACKGROUND_JOBS__FETCH_UPDATED_IN_ORG';
export const BACKGROUND_JOBS__COUNT = 'BACKGROUND_JOBS__COUNT';
export const BACKGROUND_JOBS__STOP = 'BACKGROUND_JOBS__STOP';
export const BACKGROUND_JOBS__DETAILS = 'BACKGROUND_JOBS__DETAILS';

export const BACKGROUND_JOBS__INITIAL_STATE = 0;
export const BACKGROUND_JOBS__WORKING_STATE = 1;
export const BACKGROUND_JOBS__COMPLETE_STATE = 2;
export const BACKGROUND_JOBS__INTERRUPTED_STATE = 3;
export const BACKGROUND_JOBS__FAILED_STATE = 4;

export const BACKGROUND_JOBS__DOWNLOAD_TYPE = 'ImportMailchimpListJob';
export const BACKGROUND_JOBS__UPLOAD_TYPE = 'UploadMailchimpListJob';
export const BACKGROUND_JOBS__SEND_MESSAGE = 'SendMessageTemplateJob';

export const BACKGROUND_JOBS__PROGRESS_STATES = [
  BACKGROUND_JOBS__INITIAL_STATE,
  BACKGROUND_JOBS__WORKING_STATE,
];
export const BACKGROUND_JOBS__VALID_STATES = [
  BACKGROUND_JOBS__INITIAL_STATE,
  BACKGROUND_JOBS__WORKING_STATE,
  BACKGROUND_JOBS__COMPLETE_STATE,
];
export const BACKGROUND_JOBS__INVALID_STATES = [
  BACKGROUND_JOBS__FAILED_STATE,
  BACKGROUND_JOBS__INTERRUPTED_STATE,
];

export const BACKGROUND_JOBS__SHAPE_ITEM = PropTypes.shape({
  createdAt: PropTypes.number,
  finishedAt: PropTypes.number,
  jobId: PropTypes.string,
  name: PropTypes.string,
  surveyTitle: PropTypes.string,
  surveyId: PropTypes.string,
  state: PropTypes.number,
  log: PropTypes.arrayOf(
    PropTypes.shape({
      error_messages: PropTypes.arrayOf(PropTypes.string),
      time: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
});
